<div class="tracking__list">
    <app-list-filter [options]="optionsFilter" [typeList]="typeList"
        (refreshList)="onFilterChanges.emit($event)"></app-list-filter>
    <h5 class="tracking__list--title">
        Vehículos en Ruta
    </h5>
        <ul *ngIf="!loadingCargos && !loadingMap" type="square" class="tracking__list--vehicles" infinite-scroll [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="300" [scrollWindow]="false">
        <li *ngFor="let cargo of cargos">
                <span *ngIf="cargo && cargo.licensePlate" class="vehicle-item"
                    [ngClass]="{'selected':cargo.consecutive === cargoSelected?.consecutive}">
                    <span class="vehicle-plate" (click)="emitCargoSelected(cargo)">
                        {{cargo.licensePlate | uppercase}}
                    </span>
                    <span class="vehicle-actions">
                        <i class="fas fa-map-marker-alt action-icon" 
                        (click)="emitCargoSelected(cargo)"
                        matTooltip="Ver en mapa"
                        [ngClass]="{'active': cargo.consecutive === cargoSelected?.consecutive}"></i>
                        <i *ngIf="cargo?.state === cargoStateEnum.START_SERVICE" 
                        class="fas fa-info-circle action-icon"
                        (click)="openDetailCargo(cargo)"
                        matTooltip="Ver detalles"></i>
                    </span>
                </span>
            </li>
        </ul>
        <div *ngIf="!loadingCargos && !loadingMap && !cargos?.length" class="tracking__list--no-results">
            <div class="icon"><i class="fas fa-truck"></i></div>
            <h5>No encontramos vehículos</h5>
            <p>Prueba ajustando los filtros de búsqueda.</p>
        </div>
    <div *ngIf="loadingCargos || loadingMap" class="loading-container">
        <div class="loading-spinner"></div>
        <p class="loading-message">{{loadingCargos ? 'Cargando vehículos...' : 'Actualizando ubicaciones...'}}</p>
    </div>
</div>
